import React, { Component } from 'react';
import { withStyles } from '@material-ui/core/styles';
import Button from '@material-ui/core/Button';
import AppLogo from './Comcast_555_Logo.svg';

const styles = {
  headerNav: {
    background: 'linear-gradient( 90deg, rgb(13, 41, 56) 0%, rgb(84, 116, 134) 100%)',
    boxShadow: '0px 0px 15px #999',
    position: 'fixed',
    top: '0',
    zIndex: '9',
    width: '100%',
  },
  flexContainer: {
    display: 'flex',
    flexDirection: 'row',
    padding: 0,
  },
  navBar: {
    '-ms-flex-flow': 'row nowrap',
    'flex-flow': 'row nowrap',
    '-ms-flex-pack': 'start',
    'justify-content': 'flex-start',
    margin: '0 50px',
  },
  navBarBrand: {
    'font-size': '72px',
    'font-family': '"Montserrat", "Helvetica", "Arial", sans-serif',
    'font-weight': '700',
    'text-decoration': 'none',
    color: '#fff',
    margin: '0',
    'line-height': '1',
    padding: '0',
    verticalAlign: 'middle',
  },
  navBarCollapse: {
    display: 'inline-flex',
    '-ms-flex-preferred-size': 'auto',
    'flex-basis': 'auto',
    'flex-grow': '1',
    'align-items': 'center',
  },
  navLink: {
    color: '#fff',
    display: 'block',
    'font-size': '16px',
    'font-weight': '500',
    'text-decoration': 'none',
    'border-radius': '30px',
    '-webkit-transition-duration': '500ms',
    '-o-transition-duration': '500ms',
    'transition-duration': '500ms',
    padding: '35px 15px',
  },
  appLogo: {
    position: 'absolute',
    top: -36,
    left: 20,
    width: 145,
    height: 145,
  },
  signInButton: {
    marginLeft: '30px',
    position: 'absolute',
    right: '30px',
    textDecoration: "none",
  },
  btn: {
    background: '#fff',
    color: '#2fb3fa',
    fontSize: '19px',
    fontFamily: '"Montserrat", "Helvetica", "Arial", sans-serif',
    fontWeight: '500',
    '&:hover': {
      backgroundColor: '#cccccc',
    },
  },
};

class Header extends Component {

  render() {
    const { classes } = this.props;
    return (
      <header className={classes.headerNav}>
        <div className={classes.navBar}>
          <a className={classes.navBarBrand} href="#" />
          <div className={classes.navBarCollapse} id="ca-navbar">
            <span className={classes.logoSection}>
              <a href="/">
                <img
                  className={classes.appLogo}
                  src={AppLogo}
                  alt="Comcast_555_Logo_SigComm_final_3.svg"
                />
              </a>
            </span>
            <a href="/platform" className={classes.signInButton}>
              <Button id="sign_in" className={classes.btn}>
                Sign in
              </Button>
            </a>
          </div>
        </div>
      </header>
    );
  }
}

export default withStyles(styles)(Header);
